import { BroadcastType, createPennyBroadcastSubscriber } from '../utils/pennyBroadcast';
import SentenceArrayBuilder from './SentenceArrayBuilder';
import SpeechFetcher from './SpeechFetcher';
class SpeechOrchestrator {
  constructor(speechUrl, timeout = 10000, audioPlayer, debugMode) {
    this.currentMessageId = -1;
    this.sentenceArrayBuilder = new SentenceArrayBuilder();
    this.speechUrl = speechUrl;
    this.speechFetcher = new SpeechFetcher(speechUrl, audioPlayer, timeout);
    this.audioPlayer = audioPlayer;
    this.isSoundEnabled = false;
    this.debugMode = debugMode;
    this.broadcastChannel = createPennyBroadcastSubscriber();
    this.setupListeners();
  }
  static getInstance(speechUrl, timeout, audioPlayer, debugMode) {
    if (!SpeechOrchestrator.instance) {
      SpeechOrchestrator.instance = new SpeechOrchestrator(speechUrl, timeout, audioPlayer, debugMode);
    }
    return SpeechOrchestrator.instance;
  }
  static destroyInstance() {
    if (SpeechOrchestrator.instance) {
      SpeechOrchestrator.instance.destroy();
      SpeechOrchestrator.instance = null;
    }
  }
  setupListeners() {
    this.broadcastChannel.addEventListener('message', this.handleMessage.bind(this));
  }
  handleMessage(event) {
    const message = event.data;
    if (this.debugMode) {
      console.log('Speech Orchestrator DEBUG:', message.type, message.sender, message);
    }
    switch (message.type) {
      case BroadcastType.ADD_TEXT_TO_SPEECH_QUEUE:
        if ((message.messageId === this.currentMessageId || message.force) && message.data) {
          this.sentenceArrayBuilder.addChunk(message.data);
          this.checkAndFetchAudio();
        }
        break;
      case BroadcastType.NEW_MESSAGE_REQUEST_INITIATED:
        this.currentMessageId = message.messageId;
        break;
      case BroadcastType.INTERRUPT_AUDIO_PLAYBACK:
        this.speechFetcher.stopPlaybackAndClearQueue();
        this.reset();
        break;
      case BroadcastType.ENABLE_AUDIO_PLAYBACK:
        this.isSoundEnabled = true;
        break;
      case BroadcastType.DISABLE_AUDIO_PLAYBACK:
        this.isSoundEnabled = false;
        this.speechFetcher.stopPlaybackAndClearQueue();
        this.reset();
    }
  }
  reset() {
    if (this.speechFetcher) {
      this.speechFetcher.destroy();
      this.speechFetcher = new SpeechFetcher(this.speechUrl, this.audioPlayer);
    }
    if (this.sentenceArrayBuilder) {
      this.sentenceArrayBuilder.destroy();
      this.sentenceArrayBuilder = new SentenceArrayBuilder();
    }
    this.currentMessageId = -1;
  }
  checkAndFetchAudio() {
    if (this.isSoundEnabled) {
      const sentences = this.sentenceArrayBuilder.getSentenceQueue();
      if (sentences.length > 0) {
        const audioReadyStrings = this.sentenceArrayBuilder.dequeueAllSentences();
        this.speechFetcher.addToQueue(audioReadyStrings, this.currentMessageId);
      }
    }
  }
  destroy() {
    this.broadcastChannel.removeEventListener('message', this.handleMessage.bind(this));
    this.broadcastChannel.close();
    this.speechFetcher.destroy();
  }
}
SpeechOrchestrator.instance = null;
export { SpeechOrchestrator };
let instance = null;
export const getSpeechOrchestrator = (speechUrl, timeout, audioPlayer, debugMode) => {
  if (!instance) {
    instance = SpeechOrchestrator.getInstance(speechUrl, timeout, audioPlayer, debugMode);
  }
  return instance;
};
export const destroySpeechOrchestrator = () => {
  if (instance) {
    instance.destroy();
    instance = null;
  }
};
if (module.hot) {
  module.hot.dispose(() => {
    destroySpeechOrchestrator();
  });
}